import { API_PROTECTED_PATH, API_URL_PRD } from "../config/config";
import ApiClient from "../requests";
import store from "../../store";

export async function getArticles(payload: any) {
  const _authToken = store.authToken;
  if (!_authToken) return null;

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}user/getArticles?lang=${payload.lg}&date_version=`;
  const ignoreID = [46, 12]; //Biblio et experts

  const res = await ApiClient.get(Url, _authToken);
  if (!res.forwards){
    return [];
  }

  return res.forwards
    .filter((elm: TArticle) => ignoreID.includes(elm.id) === false)
    .sort((a: { updated_at: string; }, b: { updated_at: string; }) => Date.parse(b.updated_at.split(" ")[0]) - Date.parse(a.updated_at.split(" ")[0]));
}

export async function getArticlesForId(payload: { id: number; lg: Lang }) {
  const _authToken = store.authToken;
  if (!_authToken) return null;

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}user/getArticle/${payload.id}`;

  const res = await ApiClient.get(Url, _authToken);

  return res.forward;
}

// EXPERTS
export async function getExpertsData() {
  const _authToken = store.authToken;
  if (!_authToken) return null;

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}user/getArticle/12`;
  const res = await ApiClient.get(Url, _authToken);

  if (res?.forward?.sections) {
    return res.forward.sections;
  }
  return [];
}
